import { sqliteTable, text, uniqueIndex } from "drizzle-orm/sqlite-core";
import { companies } from "./companies";

// ============================================================================
// module_migration_log — track seed/migration runs per module per company
// ============================================================================
export const moduleMigrationLog = sqliteTable("core_module_migration_log", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull().references(() => companies.id),
  module: text("module").notNull(),
  migrationKey: text("migration_key").notNull(), // e.g. "seed_v1.0.0", "migration_001"
  migrationType: text("migration_type", {
    enum: ["seed", "migration", "rollback"],
  }).notNull(),
  fromVersion: text("from_version"), // for upgrades
  toVersion: text("to_version").notNull(),
  status: text("status", {
    enum: ["pending", "running", "completed", "failed"],
  }).notNull().default("pending"),
  errorMessage: text("error_message"),
  startedAt: text("started_at"),
  completedAt: text("completed_at"),
  createdAt: text("created_at").notNull(),
}, (table) => ({
  companyModuleKeyUniq: uniqueIndex("mml_company_module_key_uniq").on(table.companyId, table.module, table.migrationKey),
}));

// Type exports
export type ModuleMigrationLog = typeof moduleMigrationLog.$inferSelect;
export type NewModuleMigrationLog = typeof moduleMigrationLog.$inferInsert;
